<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section">TABLE OF CONTENTS</h1>
<p class="crt1"><span class="hlink" href="#/tp" title="Link target outside of Sample">Title Page</span></p>
<p class="crt"><span class="hlink" href="#/cop" title="Link target outside of Sample">Copyright</span></p>
<p class="crt1"><a class="hlink" href="#/authorsnote">Author’s Note</a></p>
<p class="crt1"><a class="hlink" href="#/p01">Not That Kind of War</a></p>
<p class="crt"><span class="hlink" href="#/p02" title="Link target outside of Sample">You Do What You Do</span></p>
<p class="crt"><span class="hlink" href="#/p03" title="Link target outside of Sample">First In</span></p>
<p class="crt"><span class="hlink" href="#/p04" title="Link target outside of Sample">To Dust We Shall Return</span></p>
<p class="crt"><span class="hlink" href="#/p05" title="Link target outside of Sample">Long Time Passing</span></p>
<p class="crt1"><span class="hlink" href="#/ata" title="Link target outside of Sample">About the Author</span></p>
<p class="crt"><span class="hlink" href="#/alsoby" title="Link target outside of Sample">Also by Tanya Huff</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?9515ed4a